import React, { useState, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FiClock } from "react-icons/fi";
import pixLogo from "../../assets/pix.svg";
import { useApp } from "../../contexts/AppContext";
import {
  PageContainer,
  PixCodeBox,
  OrderNumberBox,
  QRCodeWrapper,
  ExpirationBadge,
  Separator,
} from "./styles";

export default function PixConfirmation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { whitelabel } = useApp();
  const [copied, setCopied] = useState(false);

  const { pixCode, pixQrCode, pixExpiresAt } = location.state || {};

  const expirationTime = useMemo(() => {
    if (!pixExpiresAt) return "--:--";
    return new Date(pixExpiresAt).toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }, [pixExpiresAt]);

  const handleCopyCode = async () => {
    if (!pixCode) return;
    try {
      await navigator.clipboard.writeText(pixCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = pixCode;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };

  if (!pixCode) {
    return (
      <div className="wl-page">
        <PageContainer className="text-center">
          <p
            className="font-wl-600 text-mg mt-5"
            style={{ color: whitelabel?.theme?.text_primary_color }}
          >
            Dados do pagamento Pix não encontrados.
          </p>
          <Button
            type="button"
            className="btn-default-wl text-xxs font-wl-700 mt-4"
            onClick={() => navigate("/loja")}
          >
            VOLTAR PARA A HOME
          </Button>
        </PageContainer>
      </div>
    );
  }

  return (
    <div className="wl-page">
      <PageContainer>
        {/* 1. Título */}
        <p
          className="font-wl-700 text-mg mb-1"
          style={{ color: whitelabel?.theme?.text_primary_color }}
        >
          Pedido recebido
        </p>
        <p
          className="font-wl-400 text-sm mb-3"
          style={{ color: whitelabel?.theme?.text_primary_color }}
        >
          Recebemos seu pedido. Para finalizar sua compra é só pagar com Pix!
        </p>

        {/* 2. Logo Pix + Título */}
        <div className="text-center my-3">
          <img
            src={pixLogo}
            alt="Pix"
            style={{ width: 28, height: 28, marginBottom: 6 }}
          />
          <p
            className="font-wl-600 text-sm mb-0"
            style={{ color: whitelabel?.theme?.text_primary_color }}
          >
            Pagamento via Pix
          </p>
        </div>

        {/* 3. Instruções */}
        <p
          className="font-wl-400 text-xs text-center mb-2"
          style={{ color: "#767F8D" }}
        >
          Copie e cole o código, no aplicativo do seu banco, ou escaneie o
          código QR com a câmera do seu celular.
        </p>

        {/* 4. Expiração */}
        <ExpirationBadge>
          <FiClock size={14} />
          <span className="text-xs font-wl-500">
            O código é válido até às {expirationTime}.
          </span>
        </ExpirationBadge>

        {/* 5. Código Pix */}
        <PixCodeBox>{pixCode}</PixCodeBox>

        {/* 6. Botão copiar */}
        <Button
          type="button"
          className="btn-default-wl text-xxs font-wl-700 w-100"
          onClick={handleCopyCode}
        >
          {copied ? "CÓDIGO COPIADO COM SUCESSO" : "COPIAR CÓDIGO PIX"}
        </Button>

        {/* 7. QR Code */}
        <QRCodeWrapper>
          <img
            src={pixQrCode}
            alt="QR Code Pix"
            style={{ width: 160, height: 160 }}
          />
        </QRCodeWrapper>

        {/* 8. Aviso cancelamento */}
        <p
          className="font-wl-400 text-xs text-center mb-0"
          style={{ color: "#767F8D" }}
        >
          Se o pagamento não for confirmado, não se preocupe. O pedido será
          cancelado automaticamente.
        </p>

        <Separator />

        {/* 9. Nº do Pedido */}
        <OrderNumberBox>
          <p className="font-wl-400 text-xs mb-1" style={{ color: "#999" }}>
            Nº do Pedido
          </p>
          <p
            className="font-wl-700 text-sm mb-0"
            style={{ color: whitelabel?.theme?.text_primary_color }}
          >
            {id}
          </p>
        </OrderNumberBox>

        {/* 10. Acompanhar pedido */}
        <div className="text-center mt-3 mb-4">
          <button
            type="button"
            onClick={() => navigate(`/loja/orderresumestatus/${id}`)}
            className="font-wl-600 text-sm"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: whitelabel?.theme?.text_primary_color,
              textDecoration: "underline",
              padding: 0,
            }}
          >
            Acompanhar pedido
          </button>
        </div>
      </PageContainer>
    </div>
  );
}
